import React, { useState } from "react";
import { Divider } from "@material-ui/core";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { connect } from "react-redux";
import { updateSheet } from "../../Redux/Actions/dataActions";
import MdlSidebarOverlay from "../Sidebar/MdlSidebarOverlay";
import MdlSheetContentTag from "./MdlSheetContentTag";
import MdlSheetContentCategory from "./MdlSheetContentCategory";

function SheetTagCategoryCard({ sheet, setTagModal, tagModal, setCatModal, catModal, userData, dispatch }) {
  // Lokaler Zustand für die Modale
  const [localCatModal, setCatLocalModal] = useState(false);
  const [localTagModal, setTagLocalModal] = useState(false);
  
  const isCatModalOpen = catModal !== undefined ? catModal : localCatModal;
  const isTagModalOpen = tagModal !== undefined ? tagModal : localTagModal;
  const toggleTagModal = setTagModal !== undefined ? setTagModal : setTagLocalModal;
  const toggleCatModal = setCatModal !== undefined ? setCatModal : setCatLocalModal;

   return (
    <div className="doc_box tags_overview_box" style={{ marginTop: "0px", display: "flex", flexDirection: "column", gap: "15px" }}>
      
      {/* Freie Tags verwalten */}
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
          <span className="sheet_info_header" style={{ fontSize: "14px", color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase" }}>Tags</span>
			<Button
			  variant="contained"
			  size="small"
			  startIcon={<EditIcon />}
			  onClick={() => toggleTagModal(true)}
			  style={{ backgroundColor: "#4f40b3", color: "white", textTransform: "none", borderRadius: "8px" }}
			>Bearbeiten
			</Button>		  
        </div>

        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {sheet.tags && sheet.tags.length > 0 ? (
            sheet.tags.map((tag) => (
              <span key={tag} className="sheet_info_info" style={{ backgroundColor: "#f0f0f0", padding: "3px 10px", borderRadius: "12px", fontSize: "0.85em", border: "1px solid #e0e0e0" }}>
                {tag}
              </span>
            ))
          ) : (
            <span className="sheet_info_info" style={{ fontStyle: "italic" }}>Keine Tags vorhanden.</span>
          )}
        </div>
      </div>

      <Divider style={{ margin: "5px 0" }} />

      {/* Freie Categories verwalten */}
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
          <span className="sheet_info_header" style={{ fontSize: "14px", color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase" }}>Kategories</span>
			<Button
			  variant="contained"
			  size="small"
			  startIcon={<EditIcon />}
			  onClick={() => toggleCatModal(true)}
			  style={{ backgroundColor: "#4f40b3", color: "white", textTransform: "none", borderRadius: "8px" }}
			>Bearbeiten
			</Button>
        </div>

        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {sheet.categories && sheet.categories.length > 0 ? (
            sheet.categories.map((category) => (
              <span key={category} className="sheet_info_info" style={{ backgroundColor: "#f0f0f0", padding: "3px 10px", borderRadius: "12px", fontSize: "0.85em", border: "1px solid #e0e0e0" }}>
                {category}
              </span>
            ))
          ) : (
            <span className="sheet_info_info" style={{ fontStyle: "italic" }}>Keine Kategorien vorhanden.</span>
          )}
        </div>
      </div>

      {/* Modales Tag-Fenster */}
      <MdlSidebarOverlay title="Edit Tags" onClose={() => toggleTagModal(false)} show={isTagModalOpen}>
        <MdlSheetContentTag 
          onClose={() => toggleTagModal(false)} 
          tags={sheet.tags || []} 
          sheetName={sheet.safeSheetName} 
        />
      </MdlSidebarOverlay>

      {/* Modales Category-Fenster */}
      <MdlSidebarOverlay title="Edit Categories" onClose={() => toggleCatModal(false)} show={isCatModalOpen}>
        <MdlSheetContentCategory 
          onClose={() => toggleCatModal(false)} 
          categories={sheet.categories || []} 
          sheetName={sheet.safeSheetName} 
        />
      </MdlSidebarOverlay>

    </div>
  );
}

const mapStateToProps = (state) => ({
  userData: state.user.userData,
});

const mapActionsToProps = {
  updateSheet
};

export default connect(mapStateToProps, mapActionsToProps)(SheetTagCategoryCard);
